import React, { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'

const Login = ({ onForgotPassword }) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')

  const { signIn } = useAuth()

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    if (!email || !password) {
      setError('Please fill in all fields')
      return
    }

    setIsLoading(true)
    setError('')

    try {
      const result = await signIn(email, password)
      
      if (!result.success) {
        let errorMessage = 'Login failed'
        if (result.error?.message) {
          if (result.error.message.includes('Invalid login credentials')) {
            errorMessage = 'Invalid email or password'
          } else if (result.error.message.includes('Email not confirmed')) {
            errorMessage = 'Please check your email and confirm your account'
          } else {
            errorMessage = result.error.message
          }
        }
        setError(errorMessage)
      }
    } catch (err) {
      console.error('Login error:', err)
      setError('An unexpected error occurred. Please try again.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h2 className="text-lg font-semibold text-black">Backstube Accounting</h2>
          <p className="text-sm text-gray-400 mt-1">Sign in to continue</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-xs font-medium text-gray-500 mb-1.5">
              Email
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              disabled={isLoading}
              className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm text-black placeholder-gray-300 focus:outline-none focus:border-black transition-colors disabled:bg-gray-50 disabled:text-gray-400"
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-xs font-medium text-gray-500 mb-1.5">
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              disabled={isLoading}
              className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm text-black placeholder-gray-300 focus:outline-none focus:border-black transition-colors disabled:bg-gray-50 disabled:text-gray-400"
            />
          </div>

          {error && (
            <p className="text-sm text-red-600">{error}</p>
          )}

          <button
            type="submit"
            disabled={isLoading}
            className="w-full py-2.5 bg-black text-white text-sm font-medium rounded-md hover:bg-gray-900 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
          >
            {isLoading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>

        <div className="mt-6 text-center">
          <button
            type="button"
            onClick={onForgotPassword}
            className="text-xs text-gray-400 hover:text-black transition-colors"
            disabled={isLoading}
          >
            Forgot your password?
          </button>
        </div>

        <p className="mt-8 text-center text-xs text-gray-400">
          Need an account? Contact your administrator.
        </p>
      </div>
    </div>
  )
}

export default Login
